import { store } from "store/actions/store";
import type { AppState } from "store/reducers/Reducer";
import {
  defineRecordSaves,
  disposeAllRecordSaves,
  type RecordSaveQueue,
} from "utils/recordSaveQueue";

/**
 * The session queued record saves belong to: the signed-in user, the sign-in (its generation
 * changes on every sign-in and sign-out) and the active workspace.
 */
export function currentRecordSaveSession(): string {
  const { auth, workspace } = store.getState() as AppState;
  return [auth.user_id ?? "", auth.sessionGeneration ?? 0, workspace?.activeWorkspaceId ?? ""].join(
    "\u0000"
  );
}

/**
 * `defineRecordSaves` for queues whose edits must never outlive the session that made them.
 * Edits waiting when the session changes are dropped without being sent.
 */
export function defineSessionRecordSaves<T extends object>(): (
  owner: object
) => RecordSaveQueue<T> {
  return defineRecordSaves<T>(currentRecordSaveSession);
}

// Stop every queue the moment the session changes, through any path (sign-out button, an
// expired session, another sign-in, a workspace switch), even when no budget view is open.
let watchedSession = currentRecordSaveSession();
store.subscribe(() => {
  const session = currentRecordSaveSession();
  if (session === watchedSession) return;
  watchedSession = session;
  disposeAllRecordSaves();
});
